import React, { useEffect, useState } from "react";
import * as Icons from "@mui/icons-material";
import { Button, Grid, ScrollView, TextField } from "@aws-amplify/ui-react";
import LocalizedStrings from "react-localization";
import {
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";

import { iconList } from "config/iconsList";

const IconList = ({ visible, selected, onClose, onSelect }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIcon, setSelectedIcon] = useState("");

  const handleChange = (event) => {
    setSearchTerm(event.target.value.toLowerCase());
  };

  const filteredIcons = iconList.filter((icon) =>
    icon.toLowerCase().includes(searchTerm)
  );

  const onSelectIcon = () => {
    onSelect(selectedIcon);
    setSearchTerm("");
    setSelectedIcon("");
  };

  useEffect(() => {
    setSelectedIcon(selected);
  }, [selected]);

  return (
    <CModal
      alignment="center"
      visible={visible}
      onClose={onClose}
      portal={false}
      backdrop="static"
      size="lg"
    >
      <CModalHeader>
        <CModalTitle>{strings.title}</CModalTitle>
      </CModalHeader>
      <CModalBody style={{ overflow: "hidden" }}>
        <div>
          <TextField placeholder={strings.search} onChange={handleChange} />
          <ScrollView className="mt-2" maxHeight="65vh">
            <Grid
              className="p-2"
              templateColumns={{
                base: "repeat(4, 1fr)",
                large: "repeat(6, 1fr)",
              }}
              gap={10}
            >
              {filteredIcons.map((iconName) => {
                const IconComponent = Icons[iconName];
                return (
                  <Button
                    title={iconName}
                    variation="link"
                    colorTheme="overlay"
                    backgroundColor={selectedIcon === iconName && "lightgray"}
                    size="small"
                    width="100px"
                    onClick={() => setSelectedIcon(iconName)}
                    key={iconName}
                  >
                    <Grid className="px-1" style={{ justifyItems: "center" }}>
                      <IconComponent style={{ fontSize: "30px" }} />
                      <div style={styles.iconName}>{iconName}</div>
                    </Grid>
                  </Button>
                );
              })}
            </Grid>
          </ScrollView>
        </div>
      </CModalBody>
      <CModalFooter>
        <Button size="small" onClick={onClose}>
          {strings.modal.cancel}
        </Button>
        <Button
          disabled={!selectedIcon}
          size="small"
          variation="primary"
          onClick={onSelectIcon}
        >
          {strings.modal.select}
        </Button>
      </CModalFooter>
    </CModal>
  );
};

const strings = new LocalizedStrings({
  es: {
    search: "Buscar Icono...",
    title: "Lista de Iconos",
    modal: {
      cancel: "Cancelar",
      select: "Seleccionar",
    },
  },
});

const styles = {
  iconName: {
    textOverflow: "ellipsis",
    width: "90px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textAlign: "center",
  },
};

export default IconList;
